import { ReportSaleByChannel } from "./report-sale-by-channel";
import { ReportSaleByItem } from "./report-sale-by-item";
import { SystemField } from "./system-field";

export class ReportSaleSummary extends SystemField{
    
    sale_date?:string;
    total_qty?:number;
    total_sub_amount?:number;
    total_discount?:number;
    total_vat_exempt?:number; 
    total_pax?:number;
    total_amount?:number;
    total_vat_taxable?:number;
    total_tax?:number;
    total_cost?:number;

    detail_by_items?:ReportSaleByItem[];
    detail_by_channels?:ReportSaleByChannel[];
}
